module.exports = __webpack_public_path__ + "img/40_4.a567ae88.png";